<app-toasts class="ngb-toasts" aria-live="polite" aria-atomic="true"> </app-toasts>

<!-- Load translation for APP: -->
<router-outlet *transloco="let t"></router-outlet>

<app-spinner></app-spinner>
